<template>
  <div
    class="base-type-page"
    :class="baseTypeThemeClass"
    :style="baseTypeThemeStyle"
  >
    <BaseTypePageCap :base-type="baseType" :title="resolvedTitle" :subtitle="subtitle">
      <template v-if="$slots.title" #title>
        <slot name="title" />
      </template>
    </BaseTypePageCap>
    <div class="base-type-page__body">
      <slot />
    </div>
  </div>
</template>

<script>
import BaseTypePageCap from "@/components/base_type/BaseTypePageCap.vue";
import {getBaseTypeTheme, getBaseTypeThemeClass, getBaseTypeThemeStyle} from "@/utils/baseTypeTheme";

export default {
  name: 'BaseTypeIndexShell',
  components: {
    BaseTypePageCap,
  },
  props: {
    baseType: {
      type: String,
      required: true,
      validator: (value) => ['accommodations', 'offers', 'events', 'discover'].includes(value),
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: null,
    },
  },
  computed: {
    resolvedTitle() {
      return this.title || getBaseTypeTheme(this.baseType).label
    },
    baseTypeThemeClass() {
      return getBaseTypeThemeClass(this.baseType)
    },
    baseTypeThemeStyle() {
      return getBaseTypeThemeStyle(this.baseType)
    },
  },
}
</script>
